import React from "react";
import { Clock, ArrowLeft } from "lucide-react";

const ComingSoon = ({ pageName = "Page" }) => {
  const handleBackToHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFEBB5] to-[#FFF8E6] flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-8">
          <img
            src="/assets/logo-vishwa-sanatan.svg"
            alt="Vishwa Sanatan Mahapeeth"
            className="w-32 h-32 mx-auto mb-4"
          />
        </div>

        {/* Coming Soon Icon */}
        <div className="mb-8">
          <Clock className="w-24 h-24 text-[#67142D] mx-auto animate-pulse" />
        </div>

        {/* Main Content */}
        <div className="mb-8">
          <h1 className="text-5xl font-source-serif-4 font-bold text-[#67142D] mb-4">
            {pageName} Coming Soon
          </h1>
          <p className="text-xl text-[#67142D] mb-6 font-inter">
            We are working hard to bring you something amazing. This page is under development and will be available soon.
          </p>
          <p className="text-lg text-[#67142D]/80 font-inter">
            सर्वे सन्तु सनातनाः - May all beings be blessed with eternal peace
          </p>
        </div>

        {/* Features Preview */}
        <div className="mb-8">
          <h3 className="text-2xl font-source-serif-4 font-semibold text-[#67142D] mb-4">
            What's Coming
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="bg-white/50 p-4 rounded-lg">
              <h4 className="font-semibold text-[#67142D] mb-2">Spiritual Content</h4>
              <p className="text-[#67142D]/80 text-sm">Rich spiritual resources and teachings</p>
            </div>
            <div className="bg-white/50 p-4 rounded-lg">
              <h4 className="font-semibold text-[#67142D] mb-2">Community Features</h4>
              <p className="text-[#67142D]/80 text-sm">Connect with like-minded devotees</p>
            </div>
            <div className="bg-white/50 p-4 rounded-lg">
              <h4 className="font-semibold text-[#67142D] mb-2">Interactive Tools</h4>
              <p className="text-[#67142D]/80 text-sm">Engaging spiritual tools and resources</p>
            </div>
            <div className="bg-white/50 p-4 rounded-lg">
              <h4 className="font-semibold text-[#67142D] mb-2">Regular Updates</h4>
              <p className="text-[#67142D]/80 text-sm">Fresh content and spiritual insights</p>
            </div>
          </div>
        </div>

        {/* Back to Home Button */}
        <button
          onClick={handleBackToHome}
          className="inline-flex items-center gap-2 bg-[#67142D] text-white px-8 py-3 rounded-lg hover:bg-[#B51F3B] transition-colors duration-300 font-semibold"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </button>

        {/* Footer Message */}
        <div className="mt-12 text-[#67142D]/60">
          <p className="text-sm">
            Thank you for your patience. We are committed to providing you with the best spiritual experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
